import PropTypes from "prop-types"

import { Label } from "../label"
import styles from "./index.module.css"

export const Textarea = ({ label, tooltip = "", disabled = false, value = "", placeholder = "", onChange, id }) => {
  return (
    <div>
      {label && <Label id={id} label={label} tooltip={tooltip} disabled={disabled} />}
      <div className={styles.textareaContainer}>
        <textarea
          rows={4}
          name={id}
          id={id}
          disabled={disabled}
          className={styles.textarea}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
        />
      </div>
    </div>
  )
}

Textarea.displayName = "Textarea"
Textarea.prototypes = {
  label: PropTypes.string,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.prototype,
  id: PropTypes.string.isRequired,
}
